module.exports = __webpack_public_path__ + "img/bg_wsxx.1966b78f.svg";